/*
 * Schuifbalk bij het prijsfilter, met twee grepen.
 *
 * De schuifbalk zet zijn waarde in de twee invulvakjes Van en Aan die eronder
 * staan. Pas als je de greep loslaat wordt er opnieuw gefilterd; tijdens het
 * schuiven zie je alleen de bedragen meelopen. Zonder dat onderscheid zou de
 * pagina bij elke pixel opnieuw gaan zoeken.
 */
(function () {
  if (window.customElements.get('km-prijs-schuif')) return;

  function centenNaarTekst(centen, munt) {
    var euro = (centen / 100).toFixed(2).replace('.', ',');
    return munt + euro;
  }

  class KmPrijsSchuif extends HTMLElement {
    connectedCallback() {
      this.max = parseInt(this.dataset.max, 10) || 0;
      this.munt = this.dataset.munt || '€';
      this.grepen = {
        min: this.querySelector('[data-km-greep="min"]'),
        max: this.querySelector('[data-km-greep="max"]'),
      };
      this.tonen = {
        min: this.querySelector('[data-km-toon="min"]'),
        max: this.querySelector('[data-km-toon="max"]'),
      };
      this.bereik = this.querySelector('[data-km-bereik]');
      this.velden = {
        min: document.getElementById(this.dataset.veldMin),
        max: document.getElementById(this.dataset.veldMax),
      };

      if (!this.grepen.min || !this.grepen.max) return;

      ['min', 'max'].forEach(
        function (soort) {
          var greep = this.grepen[soort];

          // Tijdens het schuiven alleen bijwerken, niet opnieuw filteren. Het
          // formulier van de filters luistert op input-gebeurtenissen, dus die
          // moeten hier stoppen.
          greep.addEventListener(
            'input',
            function (event) {
              event.stopPropagation();
              this.klopWaardenBij(soort);
              this.tekenBij();
            }.bind(this)
          );

          greep.addEventListener(
            'change',
            function (event) {
              event.stopPropagation();
              this.klopWaardenBij(soort);
              this.tekenBij();
              this.filterOpnieuw();
            }.bind(this)
          );
        }.bind(this)
      );

      // Typt iemand zelf een bedrag in de vakjes, dan schuiven de grepen mee.
      ['min', 'max'].forEach(
        function (soort) {
          var veld = this.velden[soort];
          if (!veld) return;
          veld.addEventListener(
            'change',
            function () {
              var centen = this.veldNaarCenten(veld);
              if (centen !== null) this.grepen[soort].value = centen;
              this.tekenBij();
            }.bind(this)
          );
        }.bind(this)
      );

      this.tekenBij();
    }

    veldNaarCenten(veld) {
      var tekst = (veld.value || '').replace(/\s/g, '').replace(',', '.');
      if (tekst === '') return null;
      var getal = parseFloat(tekst);
      if (isNaN(getal)) return null;
      return Math.round(getal * 100);
    }

    // De laagste greep mag niet voorbij de hoogste komen, en omgekeerd.
    klopWaardenBij(bewogen) {
      var laag = parseInt(this.grepen.min.value, 10);
      var hoog = parseInt(this.grepen.max.value, 10);

      if (laag > hoog) {
        if (bewogen === 'min') {
          this.grepen.min.value = hoog;
        } else {
          this.grepen.max.value = laag;
        }
      }
    }

    tekenBij() {
      var laag = parseInt(this.grepen.min.value, 10);
      var hoog = parseInt(this.grepen.max.value, 10);

      if (this.tonen.min) this.tonen.min.textContent = centenNaarTekst(laag, this.munt);
      if (this.tonen.max) this.tonen.max.textContent = centenNaarTekst(hoog, this.munt);

      if (this.bereik && this.max > 0) {
        this.bereik.style.left = (laag / this.max) * 100 + '%';
        this.bereik.style.right = 100 - (hoog / this.max) * 100 + '%';
      }
    }

    filterOpnieuw() {
      var laag = parseInt(this.grepen.min.value, 10);
      var hoog = parseInt(this.grepen.max.value, 10);

      // Staat een greep op zijn uiterste stand, dan hoort dat bedrag niet in de
      // link: anders staat er een filter aan dat niets weglaat.
      this.zetVeld(this.velden.min, laag > 0 ? laag : null);
      this.zetVeld(this.velden.max, hoog < this.max ? hoog : null);

      var veld = this.velden.max || this.velden.min;
      if (veld) veld.dispatchEvent(new Event('input', { bubbles: true }));
    }

    zetVeld(veld, centen) {
      if (!veld) return;
      veld.value = centen === null ? '' : (centen / 100).toFixed(2).replace('.', ',');
    }
  }

  window.customElements.define('km-prijs-schuif', KmPrijsSchuif);
})();
